import EzModalController from 'layouts/modal/modal-controller';
import events from 'lib/events';
import { triggerCustomEvent } from 'lib/helpers';

export default class DownloadLimitJoinProModalController extends EzModalController {
  connect() {
    super.connect();

    triggerCustomEvent(events.ten_download_limit.open);
  }

  joinProClick() {
    triggerCustomEvent(events.ten_download_limit.join_pro);
  }
}
